export const SET_FILTERS = "SET_FILTERS";
export const SET_PROFILE = "SET_PROFILE";
export const SET_TABLE_SETTINGS = "SET_TABLE_SETTINGS";
export const SET_LOCAL_STORE_ITEM = "SET_LOCAL_STORE_ITEM";
export const RESET_PROFILE = "RESET_PROFILE";
export const SET_LOCAL_STORE = "SET_LOCAL_STORE";
export const SET_GLOBAL_STORE = "SET_GLOBAL_STORE";
export const RESET_GLOBAL_STORE = "RESET_GLOBAL_STORE";
export const LOG_OUT = "LOG_OUT";
export const CHANGE_LOCATION = "CHANGE_LOCATION";
//# sourceMappingURL=actionTypes.js.map